import classNames from 'classnames';
import React from 'react';

import './FuturePaymentButtonWrapper.scss';

type FuturePaymentButtonWrapperComposition = {
    FirstRow: React.FC<React.PropsWithChildren>;
};

const FirstRow: React.FC<React.PropsWithChildren> = ({ children }) => {
    return <div className="future-payment__details-button-primary-row">{children}</div>;
};

const FuturePaymentButtonWrapper: React.FC<
    {
        className?: string;
    } & React.PropsWithChildren
> &
    FuturePaymentButtonWrapperComposition = ({ children, className }) => {
    return <div className={classNames(className, 'future-payment__details-button-wrapper')}>{children}</div>;
};

FuturePaymentButtonWrapper.FirstRow = FirstRow;

export default FuturePaymentButtonWrapper;
